/* batida-v7-collection.js: the category pages of the new batida.pl (Aleksandra's prototype _17, 27.09).
   Everything works without it (all products show in the collection's order, the SEO text is open).
   - category bar: bring the current category into view (sections/batida-v7-catbar)
   - 9.10 promo tile (Torciki bento) as the last tile of the grid, hidden with any filter on
   - filters (time, price, "wysyłka w całą Polskę"; 28.09 + liczba osób, smak, bez dodanego cukru, ?f= in the
     URL), sort, "Pokaż więcej", filters panel on phones (-collection-grid)
   - letter: occasion texts, live paper preview, counter, add to cart with properties[Message-Wiadomosc] (-letter)
   - "Czytaj dalej" under a long SEO text (-collection-seo) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // category bar
  document.querySelectorAll('[data-v7c-bar]').forEach(function (bar) {
    var on = bar.querySelector('.is-on');
    if (on && bar.scrollWidth > bar.clientWidth) {
      bar.scrollLeft = on.offsetLeft - (bar.clientWidth - on.offsetWidth) / 2;
    }
  });

  // filters, sort, "Pokaż więcej"
  document.querySelectorAll('[data-v7c-grid]').forEach(function (root) {
    var list = root.querySelector('[data-v7c-list]');
    if (!list) return;
    root.classList.add('v7c-js');
    /* 9.10 (Aleksandra): the promo tile ("Torciki bento", snippets/batida-v7-promo-tile) is no product: not sorted, not counted;
       it stays the LAST tile, hides while any filter is on and while products are still folded behind "Pokaż więcej" */
    var promo = list.querySelector('[data-v7c-promo]');
    var items = [].slice.call(list.children).filter(function (li) { return li !== promo; });
    var first = +root.getAttribute('data-first') || 12;
    var lo = +root.getAttribute('data-lo') || 5000, hi = +root.getAttribute('data-hi') || 20000;
    var moreBtn = root.querySelector('[data-v7c-more]');
    var countEl = root.querySelector('[data-v7c-count]');
    var emptyEl = root.querySelector('[data-v7c-empty]');
    var sortEl = root.querySelector('[data-v7c-sort]');
    var activeEl = root.querySelector('[data-v7c-active]');
    var words = [root.getAttribute('data-w1'), root.getAttribute('data-w2'), root.getAttribute('data-w5')];
    var open = false;

    function word(n) {
      if (n === 1) return words[0];
      var m10 = n % 10, m100 = n % 100;
      return (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) ? words[1] : words[2];
    }
    function picked(f) {
      return [].slice.call(root.querySelectorAll('.v7c-chip[data-f="' + f + '"][aria-pressed="true"]')).map(function (b) { return b.getAttribute('data-v'); });
    }
    function priceOk(p, ranges) {
      if (!ranges.length) return true;
      return ranges.some(function (r) { return r === 'lo' ? p <= lo : r === 'hi' ? p > hi : (p > lo && p <= hi); });
    }
    /* 28.09 "Liczba osób" (data-o) and "Smak" (data-sm): the product has ANY of the picked values (OR inside a group) */
    function anyOf(li, f, vs) {
      if (!vs.length) return true;
      var own = ' ' + (li.getAttribute('data-' + f) || '') + ' ';
      return vs.some(function (v) { return own.indexOf(' ' + v + ' ') > -1; });
    }
    /* checked checkboxes: "s" (wysyłka), 28.09 "bc" (bez dodanego cukru); the product has data-<f>="1" */
    function checked() {
      return [].slice.call(root.querySelectorAll('input[data-f]:checked')).map(function (c) { return c.getAttribute('data-f'); });
    }
    /* 28.09 the filters live in ?f= (e.g. ?f=h_24.o_do6.sm_owocowe.bc) so a filtered view can be linked; replaceState, no reload */
    function save() {
      if (!window.history || !history.replaceState || !window.URL) return;
      var parts = [].slice.call(root.querySelectorAll('.v7c-chip[data-f][aria-pressed="true"]')).map(function (b) {
        return b.getAttribute('data-f') + '_' + b.getAttribute('data-v');
      }).concat(checked());
      try {
        var u = new URL(location.href);
        if (parts.length) u.searchParams.set('f', parts.join('.')); else u.searchParams.delete('f');
        if (u.href !== location.href) history.replaceState(history.state, '', u.href);
      } catch (err) { /* old browsers */ }
    }
    (function load() {
      var f = '';
      try { f = new URL(location.href).searchParams.get('f') || ''; } catch (err) { return; }
      f.split('.').forEach(function (p) {
        if (!p) return;
        var i = p.indexOf('_'), k = i < 0 ? p : p.slice(0, i), v = i < 0 ? '' : p.slice(i + 1);
        root.querySelectorAll(v ? '.v7c-chip[data-f]' : 'input[data-f]').forEach(function (el) {
          if (el.getAttribute('data-f') !== k) return;
          if (v && el.getAttribute('data-v') === v) el.setAttribute('aria-pressed', 'true');
          if (!v) el.checked = true;
        });
      });
    })();
    /* 3.10 (Pat): "Najczęściej kupowane" - Shopify's own best-selling order of this collection, read once from
       ?view=ids&sort_by=best-selling (templates/collection.ids.liquid: product ids only) */
    var rank = null;
    function loadRank() {
      var u = location.pathname.replace(/\/$/, '') + '?view=ids&sort_by=best-selling';
      fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
        var ids = String(t || '').replace(/[^0-9,]/g, '').split(',').filter(Boolean);
        rank = {}; ids.forEach(function (id, i) { rank[id] = i + 1; });
        apply();
      }).catch(function () { rank = {}; apply(); });
    }
    function apply() {
      var hs = picked('h'), ps = picked('p'), os = picked('o'), sms = picked('sm');
      var cks = checked();
      var sort = sortEl ? sortEl.value : 'rec';
      var ordered = items.slice().sort(function (a, b) {
        var ia = +a.getAttribute('data-i'), ib = +b.getAttribute('data-i');
        var so = (+a.getAttribute('data-so') || 0) - (+b.getAttribute('data-so') || 0);   /* 30.09 Aleksandra: sold-out at the end */
        if (so) return so;
        if (sort === 'asc') return (+a.getAttribute('data-p') - +b.getAttribute('data-p')) || ia - ib;
        if (sort === 'desc') return (+b.getAttribute('data-p') - +a.getAttribute('data-p')) || ia - ib;
        if (sort === 'fast') return (+a.getAttribute('data-h') - +b.getAttribute('data-h')) || ia - ib;
        if (sort === 'best' && rank) return ((rank[a.getAttribute('data-pid')] || 9999) - (rank[b.getAttribute('data-pid')] || 9999)) || ia - ib;
        return ia - ib;
      });
      var shown = 0, total = 0;
      ordered.forEach(function (li) {
        var ok = (!hs.length || hs.indexOf(li.getAttribute('data-h')) > -1) &&
          priceOk(+li.getAttribute('data-p'), ps) &&
          anyOf(li, 'o', os) && anyOf(li, 'sm', sms) &&
          cks.every(function (f) { return li.getAttribute('data-' + f) === '1'; });
        list.appendChild(li);
        if (ok) total++;
        li.hidden = !ok || (!open && total > first);
        li.classList.remove('is-more');
        if (ok && !li.hidden) shown++;
      });
      var left = total - shown;
      var nf = hs.length + ps.length + os.length + sms.length + cks.length;
      if (promo) { list.appendChild(promo); promo.hidden = nf > 0 || left > 0; }
      if (moreBtn) {
        moreBtn.hidden = left <= 0;
        moreBtn.textContent = (root.getAttribute('data-more') || '') + ' (' + left + ')';
      }
      if (countEl) countEl.textContent = total + ' ' + word(total);
      if (emptyEl) emptyEl.hidden = total > 0;
      var n = hs.length + ps.length + os.length + sms.length + cks.length;
      if (activeEl) activeEl.textContent = n ? '(' + n + ')' : '';
      save();
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.v7c-chip');
      if (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        open = false;
        apply();
        return;
      }
      if (e.target.closest('[data-v7c-more]')) { open = true; apply(); return; }
      var tg = e.target.closest('[data-v7c-filt-toggle]');
      if (tg) {
        var x = tg.getAttribute('aria-expanded') !== 'true', fp = root.querySelector('[data-v7c-filt]');
        tg.setAttribute('aria-expanded', x ? 'true' : 'false');
        // 7.10 (Clarity review P6): wide screens - the panel starts open and "Filtry" collapses it (is-shut); phones - opens it (is-open)
        if (deskMq && deskMq.matches) fp.classList.toggle('is-shut', !x); else fp.classList.toggle('is-open', x);
      }
    });
    var deskMq = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
    function syncFilt() {
      var fp = root.querySelector('[data-v7c-filt]'), tb = root.querySelector('[data-v7c-filt-toggle]');
      if (fp && tb) tb.setAttribute('aria-expanded', (deskMq && deskMq.matches ? !fp.classList.contains('is-shut') : fp.classList.contains('is-open')) ? 'true' : 'false');
    }
    syncFilt();
    if (deskMq) { if (deskMq.addEventListener) deskMq.addEventListener('change', syncFilt); else if (deskMq.addListener) deskMq.addListener(syncFilt); }
    // 1.10 (Pat): load the rest by itself when the visitor scrolls near "Pokaż więcej" (the products are already in the page,
    // hidden; the button stays as a fallback for browsers without IntersectionObserver)
    if (moreBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        if (!open && ents.some(function (en) { return en.isIntersecting; }) && !moreBtn.hidden) { open = true; apply(); }
      }, { rootMargin: '0px 0px 400px 0px' }).observe(moreBtn);
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('input[data-f]')) { open = false; apply(); }
      if (e.target === sortEl) { if (sortEl.value === 'best' && !rank) loadRank(); else apply(); }
    });
    apply();
  });

  // letter
  document.querySelectorAll('[data-v7c-letter]').forEach(function (root) {
    var txt = root.querySelector('[data-v7c-letter-txt]');
    var prev = root.querySelector('[data-v7c-letter-prev]');
    var cnt = root.querySelector('[data-v7c-letter-cnt]');
    var add = root.querySelector('[data-v7c-letter-add]');
    var addTxt = root.querySelector('[data-v7c-letter-addtxt]');
    var paper = root.querySelector('[data-v7c-letter-paper]');
    var msg = root.querySelector('[data-v7c-letter-msg]');
    var busy = false;
    if (!txt || !add) return;
    function upd() {
      var v = txt.value.trim();
      prev.textContent = v || root.getAttribute('data-paper-empty');
      prev.classList.toggle('is-empty', !v);
      cnt.textContent = txt.value.length;
      if (add.classList.contains('is-done')) { add.classList.remove('is-done'); addTxt.textContent = root.getAttribute('data-add'); }
      msg.textContent = '';
    }
    txt.addEventListener('input', upd);
    root.addEventListener('click', function (e) {
      var o = e.target.closest('.v7c-occ');
      if (o) {
        root.querySelectorAll('.v7c-occ').forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
        txt.value = (o.getAttribute('data-text') || '').slice(0, +root.getAttribute('data-max') || 500);
        upd();
        if (!reduce) { paper.classList.remove('is-pop'); void paper.offsetWidth; paper.classList.add('is-pop'); }
        return;
      }
      if (!e.target.closest('[data-v7c-letter-add]') || busy) return;
      var v = txt.value.trim();
      if (!v) {
        txt.classList.remove('is-shake'); void txt.offsetWidth; txt.classList.add('is-shake');
        txt.placeholder = root.getAttribute('data-empty-hint');
        txt.focus();
        return;
      }
      busy = true;
      add.classList.add('is-loading');
      var rootUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
      fetch(rootUrl + '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +root.getAttribute('data-variant'), quantity: 1, properties: { 'Message-Wiadomosc': v } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch(rootUrl + '/cart.js', { credentials: 'same-origin' }).then(function (r2) { return r2.json(); });
      }).then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } })); } catch (err) { /* old browsers */ }
        add.classList.add('is-done');
        addTxt.textContent = root.getAttribute('data-done');
        if (typeof window.__batidaOpenCart === 'function') window.__batidaOpenCart();
      }).catch(function () {
        msg.textContent = root.getAttribute('data-error');
      }).then(function () {
        busy = false;
        add.classList.remove('is-loading');
      });
    });
  });

  // "Czytaj dalej"
  document.querySelectorAll('[data-v7c-clamp]').forEach(function (box) {
    var btn = box.parentNode.querySelector('[data-v7c-clamp-btn]');
    if (!btn) return;
    box.classList.add('is-clamp');
    if (box.scrollHeight <= box.clientHeight + 24) { box.classList.remove('is-clamp'); return; }
    var more = btn.textContent, less = btn.getAttribute('data-less') || more;
    btn.hidden = false;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var x = box.classList.toggle('is-clamp');
      btn.textContent = x ? more : less;
      btn.setAttribute('aria-expanded', x ? 'false' : 'true');
    });
  });
})();
